var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCloseWhite = function SvgIconCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.73 1.707a1.06 1.06 0 0 0 0-1.414c-.483-.39-1.085-.39-1.446 0L8.94 7.585 1.716.293C1.234-.097.632-.097.27.293a1.06 1.06 0 0 0 0 1.414L7.615 9 .271 16.293a1.057 1.057 0 0 0 0 1.413c.361.392.963.392 1.445 0l7.224-7.292 7.344 7.292c.361.392.963.392 1.445 0a1.057 1.057 0 0 0 0-1.413L10.385 9z"
  })));
};
export default SvgIconCloseWhite;